import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IdleService {
  public $idle = new BehaviorSubject<number>(null);
  private idleTimeout: any;
  private timeout = 29.5 * 60 * 1000; // 30 seconds for the logout timer

  constructor() {
    this.handleClick = this.handleClick.bind(this);
    this.addListeners();
  }

  public restartTimeout() {
    this.clearTimeout();
    this.idleTimeout = setTimeout(() => {
      this.$idle.next(new Date().getTime());
    }, this.timeout);
  }

  public clearTimeout() {
    clearTimeout(this.idleTimeout);
  }

  handleClick() {
    this.restartTimeout();
  }

  addListeners() {
    this.restartTimeout();
    window.addEventListener('click', this.handleClick);
    window.addEventListener('touchstart', this.handleClick);
    window.addEventListener('keyup', this.handleClick);
  }

  removeListeners() {
    window.removeEventListener('click', this.handleClick);
    window.removeEventListener('touchstart', this.handleClick);
    window.removeEventListener('keyup', this.handleClick);
  }
}
